import { SchemaType } from '../type';
export const schema = {
    id: 'plugin',
    name: '插件',
    type: SchemaType.Indivisible,
    identityField: 'pluginId',
};
